import { useTranslation } from 'react-i18next';
import {
  EvidenceContent,
  EvidenceTitle,
  ReportTextEvidenceContainer,
} from './ReportingReport.styles';

export const ReportTextEvidence = ({
  evidenceTitle,
  evidenceContent,
  hideEvidenceContent,
  'data-testid': dataTestId,
}: {
  evidenceTitle: string;
  evidenceContent: string | undefined;
  hideEvidenceContent: (props: { evidenceContent?: string }) => boolean;
  'data-testid'?: string;
}) => {
  const { t } = useTranslation();

  return (
    <ReportTextEvidenceContainer>
      <EvidenceTitle data-testid="evidence-title">
        {evidenceTitle}
      </EvidenceTitle>
      <EvidenceContent data-testid={dataTestId || 'evidence-content'}>
        {hideEvidenceContent({
          evidenceContent: evidenceContent as string,
        }) ? (
          <i data-testid="skipped">{t('public.PublicReport.skipped')}</i>
        ) : (
          evidenceContent
        )}
      </EvidenceContent>
    </ReportTextEvidenceContainer>
  );
};
